export default __webpack_public_path__ + "static/media/news54.5612490b.jpg";